/* Shared home/collection guide. Height remains in memory only. */
(function (root) {
  function recommend(raw) {
    const height = Number(raw);
    if (String(raw ?? '').trim() === '' || !Number.isInteger(height) || height <= 0) return { sizes: [], error: 'Enter a whole height in centimetres, greater than zero.' };
    if (height < 92 || height > 190) return { sizes: [], error: null };
    if (height <= 115) return { sizes: ['mini'], error: null };
    if (height <= 128) return { sizes: ['mini', 'full'], error: null };
    if (height <= 151) return { sizes: ['full'], error: null };
    if (height === 152) return { sizes: ['full', 'large'], error: null };
    return { sizes: ['large'], error: null };
  }
  root.LilPilloSizes = { recommend };
  if (typeof module !== 'undefined') module.exports = { recommend };
})(typeof window === 'undefined' ? globalThis : window);
